<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{'--width': widthVar}"  class="pageHeader">实训课成绩汇总</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <!-- <el-form-item label="模板类型">
          <el-select v-model="formInline.type" clearable placeholder="请选择用户类型 " @change="handleQuery">
            <el-option v-for="(item,index) in $store.state.qItemType" :key="index" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="学生姓名">
          <el-input v-model="formInline.student" clearable placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="课程名称">
          <el-input v-model="formInline.course_name" clearable placeholder="请输入课程名称"></el-input>
        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}室名称`">
          <el-select v-model="formInline.training_name" clearable filterable :placeholder="`请选择${$store.state.themeTitle}室名称`">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name" :value="item.training_name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="班级名称">
          <el-input v-model="formInline.class_name" clearable placeholder="请输入班级名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
          <!-- <el-button type="primary" @click="handleAdd()">新增评价条目</el-button> -->
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增</el-button>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="handleExport">{{exportTitle}}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handlePrint">打印</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" ref="table" border style="width: 100%">
        <custom-table-column fixed prop="name" width="140" label="学生">
        </custom-table-column>
        <!-- <custom-table-column prop="training_name" min-width="180" :label="`${$store.state.themeTitle}室名称`">
        </custom-table-column> -->
        <custom-table-column prop="class_name" min-width="180" label="班级名称">
        </custom-table-column>
        <custom-table-column prop="course_name" min-width="180" label="课程名称">
        </custom-table-column>
        <custom-table-column prop="training_name" min-width="180" :label="`${$store.state.themeTitle}室名称`">
        </custom-table-column>
        <custom-table-column prop="score" width="80" label="分值">
        </custom-table-column>
        <custom-table-column prop="content" min-width="200" label="备注">
        </custom-table-column>
        <!-- <custom-table-column prop="type" label="评价类型" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.type==1">学生评价课程</span>
            <span v-if="scope.row.type==2">老师评价学生</span>
          </template>
        </custom-table-column> -->
        <!-- <custom-table-column prop="display_order" width="100" label="排序">
        </custom-table-column> -->
        <!-- <custom-table-column prop="posts" label="职位">
        </custom-table-column> -->
        <!-- <custom-table-column label="组织结构" min-width="220">
          <template slot-scope="scope">
            <span v-html="formatter(scope.row)"></span>
          </template>
        </custom-table-column> -->
        <custom-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <!-- <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button> -->
            <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false"  :title="title" :visible.sync="centerDialogVisible" width="706px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="评价类型" prop="type">
          <el-select v-model="ruleForm.type" style="width:216px;" placeholder="请选择评价类型">
            <el-option v-for="(item,index) in $store.state.qItemType" :key="index" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="评价项目" prop="item">
          <el-input v-model="ruleForm.item" placeholder="请输入评价项目" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="评价内容" prop="content">
          <el-input v-model="ruleForm.content" placeholder="请输入评价内容" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="分值" prop="score">
          <el-input-number v-model="ruleForm.score" placeholder="请输入分值" style="width:216px;"></el-input-number>
        </el-form-item>
        <el-form-item label="排序" prop="display_order">
          <el-input-number v-model="ruleForm.display_order" placeholder="请输入排序" style="width:216px;"></el-input-number>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type=='add'" @click="submitFormByFun('ruleForm',creatUser)">确认</el-button>
          <el-button type="primary" v-if="type=='edit'" @click="submitFormByFun('ruleForm',updateUser)">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false"  title="提示" :visible.sync="dialogVisible" width="400px">
      <span>{{delText}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
    <OrganDialog ref="organDia"></OrganDialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import Vue from 'vue';

export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinOrgan],
  data() {
    
    return {
      classRooms: [],
      checkKeys: [],
      defaultProps: {
        children: 'sub',
        label: 'name',
      },
      formInline: {
        student: '',
        course_name: '',
        training_name: '',
        class_name: '',
      },
      ruleForm: {
        type: '',
        item: '',
        content: '',
        score: '',
        display_order: '',
      },
      treeData: '',
      rules: {
        item: [{ required: true, message: '请输入评价类型', trigger: 'blur' }],
        content: [{ required: true, message: '请输入评价内容', trigger: 'blur' }],
        score: [{ required: true, message: '请输入分值', trigger: 'blur' }],
        display_order: [{ required: true, message: '请输入排序', trigger: 'blur' }],
        type: [{ required: true, message: '请选择评价类型', trigger: 'change' }],
      },
      type: 'add',
      tableName: '实训日志',
      uid: '',
    };
  },
  created() {},
  mounted() {
    // this.getList();
    this.$store.dispatch('getTarinMent')
  },
  methods: {
    onSubmit() {
      console.log('submit!');
    },
    formatter(row) {
      let slist = row.structureList;
      if (slist && slist.length) {
        slist = slist.map((item) => {
          return item.structure_text;
        });
      }
      return slist.join('<br/>');
      // console.log(row, column)
    },
    handleSet() {
      this.centerDialogVisible = true;
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    handleBack() {
      this.$message.info('撤销中。。。');
    },
    handlePrint() {
      this.$message.info('打印中。。。');
    },
    async deleteMethod() {
      let params = { id: this.delid };
      let res = await this.$api.delet.deleteStudentGrade(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.getList();
      }
    },
    async creatUser() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      // if (params.lesson_time) {
      //   let timee = params.lesson_time.getTime() / 1000;
      //   params.lesson_time = this.$until.getTimeStr(timee, '-');
      // }
      let res = await this.$api.creat.creatQItems(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateUser() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      // console.log(params)
      // return
      let res = await this.$api.update.updateQItem(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleQuery() {
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.query.getQulityGrades(params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
